import React, { useContext, useState } from 'react';
import DataSourceSelector from '../DataSourceSelector';
import { connect, useIntl, useLocation } from 'umi';
import { Bubble } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import "./index.scss";
import { parseUrlInfo } from '../../utils/utils';
import { formatOptionsData } from './_utils/common';
import { OptionDataType } from './_types';
import { useSelectArrObj } from '../../utils/customHook';
import { FilterContext } from '../PageContainer/context';
import classNames from 'classnames';

interface RankListDropdownCoProps {
  data: any;
  changeData: (key: string, value: string) => void;
  bubbleFormatContent?: string;
  className?: string;
  dataKey?: string;
  gameConfig: any;
}

const RankListDropdownCo: React.FC<RankListDropdownCoProps> = (props) => {
  const { data, changeData, bubbleFormatContent = 'realtime_metrics', className, dataKey = '', gameConfig } = props;
  const { locale, formatMessage } = useIntl();
  const [isHover, setIsHover] = useState(false);
  const contextObj = useContext(FilterContext);
  const { filterVal } = contextObj || {};
  const { filterDefaultSelect, pagePath } = filterVal || {};

  const { page_selector: pageSelector = [] } = gameConfig || {};

  const location = useLocation();
  const pathInfo = parseUrlInfo(location.pathname);
  const { realPath } = pathInfo || {};
  let SEPARATED_OPTIONS = useSelectArrObj(filterVal, false, false, filterDefaultSelect, pagePath, true);
  SEPARATED_OPTIONS = SEPARATED_OPTIONS?.filter((item: { groupKey: string; }) => item?.groupKey !== 'accumulated');

  // 获取 SEPARATED_OPTIONS 的第一项的值作为默认值
  const defaultOptionValue = SEPARATED_OPTIONS.length > 0 ? SEPARATED_OPTIONS[0]?.value : undefined;

  // 如果 data[dataKey] 不在 SEPARATED_OPTIONS 的值列表中，则使用 defaultOptionValue
  const selectedValue = SEPARATED_OPTIONS.some((item: { value: string; }) => item.value === data[dataKey]) ? data[dataKey] : defaultOptionValue;

  const optionsData: OptionDataType[] = formatOptionsData(pageSelector, realPath, locale, SEPARATED_OPTIONS);

  return (
    <div className="dbd-realtime-country-flex">
      <DataSourceSelector
        className={classNames('realtime-dropdown-dimension', className)}
        isHaveAccumulated={false}
        style={{ minWidth: 210, margin: 0 }}
        formValue={filterVal}
        value={selectedValue}
        onSelect={(value) => {
          changeData(dataKey, value);
        }}
        {...(optionsData.length > 0 && {optionsData})}
      />
      <div className="port-item">
        <div
          onMouseOver={() => {
            setIsHover(true);
          }}
          onMouseOut={() => {
            setIsHover(false);
          }}
        >
          <Bubble
            dark
            placement="top-end"
            arrowPointAtCenter
            style={{ maxWidth: '430px' }}
            content={formatMessage({ id: bubbleFormatContent })}
          >
            <div>
              <SvgIcon
                className="port-icon"
                type={isHover ? 'alert-circle-action' : 'alert-circle-m'}
              />
            </div>
          </Bubble>
        </div>
      </div>
    </div>
  );
};

export default connect((state: any) => {
  const { dashboardSetting: { gameConfig } } = state;
  return {
    gameConfig,
  };
})(RankListDropdownCo);